import { render } from "./ToothPositionQuestion.vue?vue&type=template&id=f139983a&scoped=true"
import script from "./ToothPositionQuestion.vue?vue&type=script&lang=js"
export * from "./ToothPositionQuestion.vue?vue&type=script&lang=js"

import "./ToothPositionQuestion.vue?vue&type=style&index=0&id=f139983a&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f139983a"]])

export default __exports__